// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";


// import { getFirestore } from "firebase/firestore";



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsDXMUjmYUSVcdHCEuZ108x8rDipVumJQ",
  authDomain: "personalpotfolio.firebaseapp.com",
  projectId: "personalpotfolio",
  storageBucket: "personalpotfolio.firebasestorage.app",
  messagingSenderId: "744227451591",
  appId: "1:744227451591:web:06b843556983b778ed04e2"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
const auth = getAuth(app);
const db = getFirestore(app);

const storage = getStorage(app);

export { auth, db, storage, collection, addDoc, ref, uploadBytes, getDownloadURL, firebaseConfig };
// Export auth and db for use in other parts of the app
// export const db = getFirestore(app);
